<section class="queue-stats" [class.compact]="compact">
  <div class="header-row">
    <h2>{{ title }}</h2>
    <div class="polling-meta">
      Polling every {{ (visiblePollIntervalMs / 1000).toFixed(1) }}s while tab is visible
    </div>
  </div>

  @if (isPaused) {
    <p class="state-text subtle-text">Polling paused while tab is hidden.</p>
  }

  @if (isLoading && !stats) {
    <p class="state-text">Loading queue stats...</p>
  }

  @if (errorMessage && !stats) {
    <p class="state-text error-text">{{ errorMessage }}</p>
  }

  @if (stats) {
    @if (compact) {
      <div class="compact-row-wrap">
        <div class="compact-metrics-row">
          <div class="compact-item"><span>Workers</span><strong>{{ stats.workers.operational_count }}</strong></div>
          <div class="compact-item"><span>Processing</span><strong>{{ stats.jobs.processing_count }}</strong></div>
          <div class="compact-item"><span>Queued</span><strong>{{ stats.jobs.queued_count }}</strong></div>
          <div class="compact-item"><span>Oldest</span><strong>{{ formatSeconds(stats.jobs.oldest_queued_age_seconds) }}</strong></div>
          <div class="compact-item">
            <span>Redis</span>
            <strong [class.good]="stats.redis.ok" [class.bad]="!stats.redis.ok">
              {{ stats.redis.ok ? 'OK' : 'DOWN' }}
            </strong>
          </div>
          <div class="compact-item"><span>Warnings</span><strong>{{ stats.warnings.length }}</strong></div>
        </div>
      </div>
    } @else {
      <div class="metrics-grid">
        <div class="metric-card">
          <div class="metric-label">Operational workers</div>
          <div class="metric-value">{{ stats.workers.operational_count }}</div>
        </div>
        <div class="metric-card">
          <div class="metric-label">Processing now</div>
          <div class="metric-value">{{ stats.jobs.processing_count }}</div>
        </div>
        <div class="metric-card">
          <div class="metric-label">Queued now</div>
          <div class="metric-value">{{ stats.jobs.queued_count }}</div>
        </div>
        <div class="metric-card">
          <div class="metric-label">Oldest queued age</div>
          <div class="metric-value">{{ formatSeconds(stats.jobs.oldest_queued_age_seconds) }}</div>
        </div>
        <div class="metric-card">
          <div class="metric-label">Redis health</div>
          <div class="metric-value" [class.good]="stats.redis.ok" [class.bad]="!stats.redis.ok">
            {{ stats.redis.ok ? 'OK' : 'DOWN' }}
          </div>
        </div>
        <div class="metric-card">
          <div class="metric-label">Redis ping</div>
          <div class="metric-value">{{ stats.redis.ping_ms }} ms</div>
        </div>
      </div>

      <div class="checked-at">Last checked: {{ formatCheckedAt(stats.checked_at_epoch_ms) }}</div>

      @if (stats.warnings.length > 0) {
        <section class="warnings">
          <h3>Warnings</h3>
          <ul>
            <li *ngFor="let warning of stats.warnings">{{ warning }}</li>
          </ul>
        </section>
      }
    }

    @if (showDetails && !compact) {
      <section class="details">
        <h3>Queue Details</h3>
        <div class="details-grid">
          <div><strong>Queue name:</strong> {{ stats.queue_name }}</div>
          <div><strong>In system:</strong> {{ stats.jobs.in_system_count }}</div>
          <div><strong>Worker processing:</strong> {{ stats.workers.processing_count }}</div>
          <div><strong>Worker idle:</strong> {{ stats.workers.idle_count }}</div>
          <div><strong>Configured processes/container:</strong> {{ stats.workers.configured_processes_per_container }}</div>
          <div><strong>Heartbeat interval:</strong> {{ formatSeconds(stats.workers.heartbeat_interval_seconds) }}</div>
          <div><strong>Heartbeat TTL:</strong> {{ formatSeconds(stats.workers.heartbeat_ttl_seconds) }}</div>
          <div><strong>Queue utilization:</strong> {{ stats.jobs.queue_utilization_pct }}%</div>
        </div>
      </section>

      <section class="workers">
        <h3>Worker Details</h3>
        @if (!stats.workers.details.length) {
          <p class="state-text subtle-text">No worker details available.</p>
        } @else {
          <div class="workers-table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Worker ID</th>
                  <th>Hostname</th>
                  <th>Process</th>
                  <th>PID</th>
                  <th>Status</th>
                  <th>Current Job ID</th>
                  <th>Heartbeat Age</th>
                  <th>Uptime</th>
                  <th>Current Job Age</th>
                  <th>Last Seen</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let worker of stats.workers.details; trackBy: trackWorker">
                  <td>{{ worker.worker_id }}</td>
                  <td>{{ worker.hostname }}</td>
                  <td>{{ worker.process_name }}</td>
                  <td>{{ worker.pid }}</td>
                  <td>{{ worker.status }}</td>
                  <td>{{ worker.current_job_id || '—' }}</td>
                  <td>{{ formatSeconds(worker.heartbeat_age_seconds) }}</td>
                  <td>{{ formatSeconds(worker.uptime_seconds) }}</td>
                  <td>{{ formatSeconds(worker.current_job_age_seconds) }}</td>
                  <td>{{ formatCheckedAt(worker.last_seen_epoch_ms) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        }
      </section>
    }
  }

  @if (errorMessage && stats) {
    <p class="state-text error-text subtle-error">{{ errorMessage }}</p>
  }
</section>
